import { Component, Inject, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';
import ScrapAgentService from '@/service/scrap-agent.service';

interface AppInfo {
  redirectUrl: string;
  clientId: string;
  scope: string;
  appId: number;
  clientSecret: string;
}
@Component({
  components: { DsModal },
})
export default class AccountTwitterLoginComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @Prop({ type: Array, required: false }) dataSourceSetting!: any;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  @Inject('scrapAgentService')
  public scrapAgentService: () => ScrapAgentService;

  showModal = this.open;
  formData = {
    accountId: null,
    accountName: '',
    password: '',
  } as any;
  appInfo: AppInfo | null = null;
  messageProcessed = false;
  authState: string;
  redirectUrl: string;

  @Watch('open')
  async onOpenChange(value: boolean) {
    this.showModal = value;
    this.messageProcessed = false;
    window.removeEventListener('message', this.receiveMessage);
    window.addEventListener('message', this.receiveMessage, false);
    if (value) {
      this.scrapAgentService()
        .getAppInfo(this.syncedChannelConnect.channelType)
        .then((result: any) => {
          if (result && result.body && result.body.length > 0) {
            this.appInfo = {
              appId: result.body[0].appId,
              redirectUrl: result.body[0].redirectUrl,
              clientId: result.body[0].clientId,
              scope: result.body[0].scope,
              clientSecret: result.body[0].clientSecret,
            };
          }
        })
        .catch(error => {
          console.error('Failed to fetch app info:', error);
        });
    }
  }

  generateWindowId(): string {
    return 'id_' + Math.random().toString(36).substr(2, 9);
  }
  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage);
  }
  async generateCodeChallengeFromVerifier(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);

    const base64 = btoa(String.fromCharCode(...Array.from(new Uint8Array(hashBuffer))));
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  async openGooglePopup() {
    console.log(this.appInfo, 'XApp');
    this.redirectUrl = window.location.origin + '/api/public/goAuth';
    this.authState = this.generateWindowId();
    const clientId = this.appInfo.clientId;
    // const code_verifier = 'goover.ai';
    // const code_challenge = await this.generateCodeChallengeFromVerifier(code_verifier);
    // console.log(code_challenge, 'code_challenge');
    const authUrl =
      `https://x.com/i/oauth2/authorize` +
      `?response_type=code` +
      `&client_id=${clientId}` +
      `&redirect_uri=${this.redirectUrl}` +
      `&scope=${this.appInfo.scope}` +
      `&state=${this.authState}` +
      `&prompt=login` +
      `&code_challenge=ycbxnR_xs-RK8mrNhtv0ZymGWdbNfBn34BuP0N3Deik` +
      `&code_challenge_method=S256`;

    const popup = window.open(authUrl, 'TwitterAuth', 'width=600,height=600');
  }
  receiveMessage(event: MessageEvent) {
    if (this.messageProcessed) {
      return;
    }
    // Verify that the message payload contains the expected state and authorization_code.
    if (event.data && event.data.authorization_code && event.data.state === this.authState) {
      this.messageProcessed = true;
      const authCode = event.data.authorization_code;
      console.log('Received matching authorization code:', authCode);
      this.handleAccountConnect(authCode).then(r => {});
    } else {
      console.warn('Ignoring unexpected message payload:', event.data);
    }
    this.messageProcessed = false;
  }

  async handleAccountConnect(authorizationCode: string) {
    console.log('Received matching authorization code:', authorizationCode);
    const payload = {
      userKey: JSON.parse(localStorage.getItem('localStorageUser') || '{}')?.id || null,
      chanelName: this.syncedChannelConnect.channelType,
      avatar: 'https://dzh91b51qfr7r.cloudfront.net/social-channel-thumb/twitter.png',
      clientId: this.appInfo.clientId,
      authorizationCode: authorizationCode,
      appId: this.appInfo.appId,
      clientSecret: this.appInfo.clientSecret,
      redirectUrl: this.redirectUrl,
      scope: this.appInfo.scope,
    };
    this.authState = null;
    this.messageProcessed = false;
    try {
      const res = await this.scrapAgentService().addUserAccount(payload);
      const responseBody = res?.data?.body?.body?.body;
      // if (!responseBody?.isSuccess) {
      //   alert('Authorization failed. Please try again.');
      //   return;
      // }
      if (!this.syncedChannelConnect.accounts) {
        this.syncedChannelConnect.accounts = [];
      }
      if (res) {
        this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messAuSuccess')}`, {
          toaster: 'b-toaster-bottom-right',
          title: `${this.$t('scrap-agent.toast.add-account.titleAuSuccess')}`,
          variant: 'success',
          solid: true,
          autoHideDelay: 5000,
        });
      }
      this.$emit('modal:close', true, responseBody.accountId);
    } catch (error) {
      this.$bvToast.toast(`${this.$t('scrap-agent.toast.add-account.messFail')}`, {
        toaster: 'b-toaster-bottom-right',
        title: `${this.$t('scrap-agent.toast.add-account.titleAuFail')}`,
        variant: 'danger',
        solid: true,
        autoHideDelay: 5000,
      });
      console.log(error.detail, 'resutl data body');
    }
  }
}
